<template>
  <p v-if="customer.full_name" class="text-sm text-gray-900 font-bold">{{ customer.full_name }}</p>
  <p class="text-sm text-gray-900 font-bold">
    <a :href="`tel:${customer.phone.e164}`" class="text-primary underline">{{ customer.phone.national }}</a>
  </p>
  <p class="text-sm text-gray-900" v-if="customer.gender.id !== 'other'">
    Пол: <strong>{{ customer.gender.name }}</strong>
  </p>
  <p class="text-sm text-gray-900" v-if="customer.birth_date && customer.birth_date.date">
    Дата рождения: <strong>{{ customer.birth_date.date }}</strong>
  </p>
</template>

<script>
export default {
  props: {
    customer: {
      required: true,
      type: Object,
    },
  },
}
</script>
